import styled from "styled-components"

export const AdminWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    .admin_content{
        padding-bottom: 50px
    }
`
